import React ,{ useState, useEffect } from 'react'
import {
  API_URL
} from '../Constants';
function PendingPayment(props) {
  const { pendingpayment, billing, onPendingPaymentStatusChange,token } = props;
  const [gateways, setGateways] = useState(null);
  
  useEffect(() => {
    async function init() {
      const { id, secret, status } = pendingpayment;
      if (status !== 'paid' && status!=='failed') {
        let isUnpaid = true;
        if (status === 'waiting_for_zp'){

          const res = await fetch(`${API_URL}/api/finance/pendingpayment/zarinpal/verify/${secret}`,
          {
            method: 'GET',
          });
          try {
            if (res.status === 200){
              pendingpayment.status = 'paid';
            }else{
              pendingpayment.status = 'failed';
            }
            onPendingPaymentStatusChange(pendingpayment);
            isUnpaid = false;
          } catch (e) {
            console.log(e);
            console.log(res);
          }
        }
        if (isUnpaid){
          const res = await fetch(`${API_URL}/api/finance/pendingpayment/gateways/${id}/${secret}`,
          {
            method: 'GET',
            headers: { Authorization: `Token ${token}`, "Content-Type": "application/json" }
          });
        try {
          const result = await res.text()
          setGateways(result)
        } catch (e) {
          console.log(e);
          console.log(res);
        }
        }
      }
    }
    init();
    
  },[pendingpayment,onPendingPaymentStatusChange,token])

  const {  amount, discount, currency, invoice_id, status } = pendingpayment;
  
  return (
    <div className={`alert ${(status === 'paid') ? 'alert-success' : 'alert-warning'}`}><p className='fw-bold'>Invoice</p>
      <p className='fw-bold'> {invoice_id}</p>
      <p className='text-danger'>Discount: {discount} {currency}</p>
      <p className='text-muted fw-bold'>Amount: {amount} {currency}</p>
      <p>Billing: {billing.price} {billing.currency} / {billing.human_readable_billing_cycle}</p>
      <p>Status: {status}</p>
      {gateways !== null && <div dangerouslySetInnerHTML={{__html:gateways}}></div>}
      {status !== 'paid' && status !== 'pending' && <button onClick={(e)=>window.location.reload()} className='btn btn-primary'>Refresh</button>}
    </div>
  )
}

export default PendingPayment